import axios from "axios";

const API = axios.create({
    baseURL: "https://api.zyphronex.com/api",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// REQUEST INTERCEPTOR
API.interceptors.request.use(
    (config) => {
        // Get token from localStorage
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Add X-CSRF-TOKEN header (empty as per your example)
        config.headers["X-CSRF-TOKEN"] = "";

        // Log the request for debugging
        console.log("API Request:", {
            url: config.url,
            method: config.method,
            headers: config.headers,
            params: config.params,
        });

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

// RESPONSE INTERCEPTOR
API.interceptors.response.use(
    (response) => {
        // Log successful responses for debugging
        console.log("API Response:", {
            url: response.config.url,
            status: response.status,
            data: response.data,
        });
        return response;
    },

    (error) => {
        // Log error responses for debugging
        console.error("API Error:", {
            url: error.config?.url,
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
        });

        // Handle common error scenarios
        if (error.response?.status === 401) {
            // Token expired or invalid
            console.log("Unauthorized - clearing token");
            localStorage.removeItem("token");
            // Optionally redirect to login
            // window.location.href = '/login';
        }

        return Promise.reject(error);
    }
);

export default API;